module.exports = __webpack_public_path__ + "img/59GIACCA-GHANDI-U-COLORI-LINO9.5e541910.jpg";